import Account from './Account';

export { Account };



// WEBPACK FOOTER //
// src/modules/screens/settings/Account/components/index.js